const intToTime = (t) => {
  let hours = `${parseInt(t / 60)}`;
  let minutes = `${t % 60}`;

  if (hours.length === 1) hours = `0${hours}`;
  if (minutes < 10) minutes = `0${minutes}`;

  return `${hours}:${minutes}`;
};

export default intToTime;
